import { useDuplicateProject } from "@/hooks/use-duplicate-project";
import { Button } from "../ui/button";
import { imagineStore } from "@/stores/imagine.store";

export function ForkProjectCallout() {
  const projectId = imagineStore.use.projectId();
  const { mutate: duplicateProject, isPending: isDuplicating } =
    useDuplicateProject();

  return (
    <div className="p-3 py-4 b-10">
      <div className="border bg-muted rounded-2xl p-4 space-y-1">
        <h1 className="text-md font-medium">Make it your own?</h1>
        <p className="text-sm text-muted-foreground">
          Fork this project to start customizing it in your own account.
        </p>
        <Button
          onClick={() => duplicateProject({ projectId: projectId! })}
          loading={isDuplicating}
          loadingText="Forking..."
          variant="default"
          size="sm"
          className="mt-2"
        >
          Fork
        </Button>
      </div>
    </div>
  );
}
